module.exports = __webpack_public_path__ + "static/media/Q688FoxStNW_2018-06-25_128.47fbf0e8.jpg";